import { render } from "./PrintProductPriceTag.vue?vue&type=template&id=39aab3d6&scoped=true&ts=true"
import script from "./PrintProductPriceTag.vue?vue&type=script&lang=ts"
export * from "./PrintProductPriceTag.vue?vue&type=script&lang=ts"

import "./PrintProductPriceTag.vue?vue&type=style&index=0&id=39aab3d6&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39aab3d6"]])

export default __exports__